export default {
  setSidebarIsOpen(state, payload) {
    state.sidebar.isOpen = payload;
  },
};
